/**
 * @prettier
 */

import React from 'react';
import MultiSamples from 'cards/components/common/SingleSample/MultiSample/MultiSample';

const MultiSamplesTutorialModal = () => {
  return <MultiSamples.TutorialModal />;
};

export default MultiSamplesTutorialModal;
